module.exports = __webpack_public_path__ + "img/6.f2219ae2.jpg";